import React from "react";
import PinInput from "react-pin-input";

function PinInputHorizon() {
  return (
    <div className="mt-7 mb-4 flex w-full items-center justify-center">
      <PinInput
        length={4}
        initialValue=""
        onChange={(value, index) => {}}
        type="numeric"
        inputMode="number"
        style={{ marginBottom: "10px" }}
        inputStyle={{
          borderWidth: "2px",
          width: "92px",
          height: "92px",
          borderColor: "#E0E5F2",
          borderRadius: "16px",
          color: "#2B3674",
          fontSize: "36px",
        }}
        inputFocusStyle={{ borderColor: "#4318FF", borderWidth: "3px" }}
        onComplete={(value, index) => {}}
        autoSelect={true}
        regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
      />
    </div>
  );
}

export default PinInputHorizon;
